import React, { PureComponent } from 'react';
import * as d3 from 'd3';
import * as _ from 'lodash';
import { networkCORDIS } from '../../common/vega/VegaSpecifications';
import Preloader from '../../components/Preloader';
import VegaChart from '../../common/vega/VegaChart';
import { Grid, Dropdown } from 'semantic-ui-react';
import { jLouvain } from '../../common/jlouvain';
import { CSVLink } from "react-csv";
import {strings} from '../../common/translations';

class DataVizNetworkCORDIS extends PureComponent {
    constructor() {
        super()
        this.state = {
            programFilter: undefined,
            countryFilter: undefined,
            activityTypeFilter: undefined
        };
    }


    getDropDownOptions(data, activityTypes) {
        // get list of programmes
        const programmesOptions = _.map(
            _.map(_.uniqBy(data, 'programme'), 'programme').sort(),
            (program, index) => ({
                key: index,
                text: program,
                value: program
            })
        );

        // get list of activity types
        const activityTypesOptions = _.map(
            _.map(_.uniqBy(activityTypes, 'activity_type'), 'activity_type').sort(),
            (activity_type, index) => ({
                key: index,
                text: activity_type,
                value: activity_type
            })
        );

        // hash to find activity types by org. name
        // and define activity types for orgs
        var orgTypes = {}
        activityTypes = _.forEach(
            activityTypes,
            o => _.set(orgTypes, o.institution, o.activity_type)
        );
        data.forEach(o => {
            o.partnerActivityType = orgTypes[o.partner];
            o.toscana_instActivityType = orgTypes[o.toscana_inst];
        });

        this.setState({
            programmesOptions: programmesOptions,
            activityTypesOptions: activityTypesOptions,
            // activityTypesOptions: _.filter(activityTypesOptions, o => o.text !== 'Tuscan Research Centers'),
            data: data
        });
    }



    /**
     * 
     */
    getNetwork(data) {
        const {
            programFilter,
            countryFilter,
            activityTypeFilter
        } = this.state;


        const filteredData = _.chain(data)
            .filter(o => {
                return _.isNil(programFilter) || (o.programme === programFilter)//_.isEmpty(programFilter) || _.indexOf(programFilter, o.programme) != -1;
            })
            .filter(o => {
                return _.isNil(countryFilter) || (o.partner_country === countryFilter)//_.isEmpty(countryFilter) || _.indexOf(countryFilter, o.partner_country) != -1;
            })
            .filter(o => {
                return _.isNil(activityTypeFilter) || 
                    ((o.partnerActivityType && o.partnerActivityType === activityTypeFilter && o.toscana_instActivityType === activityTypeFilter) || (o.toscana_instActivityType && o.toscana_instActivityType === activityTypeFilter))
            })
            .filter(o => {
                // if no program filter applied, control
                // the size of the network by dropping
                // low collaborations
                if (_.isEmpty(programFilter))
                    return +o.collab_projects > 1;
                else
                    return +o.collab_projects > 1;

            })
            .value();

        // get collaborating countries

        // console.log("FILTERED DATA");
        // console.table(filteredData);

        const activeCountriesOptions = _.map(
            _.map(_.uniqBy(filteredData, 'partner_country'), 'partner_country').sort(),
            (country, index) => ({
                key: index,
                text: country,
                value: country
            })
        );

        // get unique Tuscany org.
        const tuscanyOrgs = _.uniqBy(filteredData, 'toscana_inst').map(o => {
            return {
                name: o.toscana_inst,
                activityType: o.toscana_instActivityType
            }
        });

        // get unique non-Tuscany orgs.
        const partnerOrgs = _.uniqBy(filteredData, 'partner').map(o => {
            return {
                name: o.partner,
                activityType: o.partnerActivityType
            };
        });

        // join all orgs and assign unique ID
        let allOrgs = _.concat(tuscanyOrgs, partnerOrgs).map((o, index) => {
            return _.set(o, 'index', index)
        });

        let allCollaborations = _.chain(filteredData)
            .map(o => {
                return {
                    source: _.find(allOrgs, ['name', o.toscana_inst]).index,
                    target: _.find(allOrgs, ['name', o.partner]).index,
                    count: +o.collab_projects
                };
            })
            .value();

        allOrgs = _.chain(allOrgs)
            .forEach(org => {
                org.edges = _.filter(
                    allCollaborations,
                    collab => collab.source === org.index || collab.target === org.index
                ).length;
            })
            .value();


        // perform community detection
        var community = jLouvain()
            .nodes(_.map(allOrgs, 'index'))
            .edges(allCollaborations);
        var result = community();
        allOrgs.forEach(org => {
            org.cluster = result[org.index];
        })

        return { allOrgs, allCollaborations, activeCountriesOptions };
    }



    async componentDidMount() {

        // Translate legen title
        networkCORDIS["legends"][0]["title"] = strings.RETI_COLLABORAZIONE.CHARTS.NETWORK_CORDIS.LEGEND_TITLE;


        const data = await d3.csv('data/codis_collab_network_noroles_progs.csv');
        const activityTypes = await d3.csv('data/codis_collab_network_activity_types_v3.csv');
        this.getDropDownOptions(data, activityTypes);
    }



    render() {
        const {
            programmesOptions,
            activityTypesOptions,
            data
        } = this.state;

        if (data) {
            const { allOrgs, allCollaborations, activeCountriesOptions } = this.getNetwork(data);
            return <Grid centered>
                <Grid.Row centered className="mb-0">
                    <Dropdown
                        placeholder={strings.RETI_COLLABORAZIONE.CHARTS.NETWORK_CORDIS.SELECTOR_PROGRAMME_PLACEHOLDER}
                        selection
                        clearable
                        options={programmesOptions}
                        onChange={(event, data) => {
                            this.setState({
                                programFilter: _.isEmpty(data.value) ? undefined : data.value
                            });
                        }}
                        className='dropdown-cordis-programs'
                    />
                    <Dropdown
                        placeholder={strings.RETI_COLLABORAZIONE.CHARTS.NETWORK_CORDIS.SELECTOR_PARTNER_PLACEHOLDER}
                        selection
                        clearable
                        options={activeCountriesOptions}
                        onChange={(event, data) => {
                            this.setState({
                                countryFilter: _.isEmpty(data.value) ? undefined : data.value
                            });
                        }}
                        className='dropdown-cordis-partners ml-2'
                    />
                    <Dropdown
                        placeholder={strings.RETI_COLLABORAZIONE.CHARTS.NETWORK_CORDIS.SELECTOR_ACTIVITY_PLACEHOLDER}
                        selection
                        clearable
                        options={activityTypesOptions}
                        onChange={(event, data) => {
                            this.setState({
                                activityTypeFilter: _.isEmpty(data.value) ? undefined : data.value
                            });
                        }}
                        className='dropdown-cordis-partners ml-2'
                    />
                </Grid.Row>
                <Grid.Row centered className="mt-0">
                    {allOrgs.length > 0 ?
                        <VegaChart
                            chartClass={'dataviz-network-cordis'}
                            height={1500}
                            autoSize={'none'}
                            dataDefs={[
                                {
                                    name: 'node-data',
                                    values: allOrgs
                                },
                                {
                                    name: 'link-data',
                                    values: allCollaborations
                                }
                            ]}
                            spec={networkCORDIS}
                        />
                        :
                        <div className="emptystate">Nessun dato disponibile</div>
                    }
                </Grid.Row>
                <Grid.Row className="border-top">
                    <Grid.Column width={16} className="d-flex flex-wrap">
                        <CSVLink data={data} 
                                 className="ui red circular icon button mx-auto"
                                 filename={"collaborazioneProgettiEuropei.csv"}>
                                    <i aria-hidden="true" className="download icon"></i>
                                </CSVLink>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        }
        else {
            return <Preloader message="Caricando i dati" />
        }
    }
}

export default DataVizNetworkCORDIS;